import { SVGProps, Ref, forwardRef } from 'react';

export const WalletFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M15.99 6.632q.006.333.006.7v1.333c0 4.665-.667 5.332-5.332 5.332H5.332C.667 13.997 0 13.33 0 8.665V7.332q0-.367.006-.7h5.502c.452 1.004 1.24 1.7 2.49 1.7s2.038-.696 2.49-1.7z"
                fill="currentColor"
            />
            <path
                d="M15.917 5.23C15.64 2.454 14.513 2 10.664 2H5.332C1.483 2 .356 2.453.079 5.23h6.449c.082.4.2.744.35 1.015.26.468.577.686 1.12.686s.86-.218 1.12-.686c.15-.27.268-.615.35-1.015z"
                fill="currentColor"
            />
        </g>
    </svg>
));
WalletFilledSize16Glyph.displayName = 'WalletFilledSize16Glyph';
